/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/
export default function debounce<T extends (...args: any[]) => void>(callback: T, wait: number = 300) {
    let timeout: number | null = null;

    function cancel() {
        if (timeout !== null) {
            window.clearTimeout(timeout);
        }
    }

    function debounced(...args: Parameters<T>) {
        cancel();
        timeout = window.setTimeout(callback.bind(null, ...args), wait);
    }

    debounced.cancel = cancel;
    return debounced;
}